"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodFormData = function (formData) {
    if (formData.invoice.paymentMeans.type === "DomesticTransfer") {
        return {
            type: formData.invoice.paymentMeans.type,
            domesticTransfer: formData.invoice.paymentMeans.domesticTransfer
        };
    }
    if (formData.invoice.paymentMeans.type === "DomesticClaim") {
        return {
            type: formData.invoice.paymentMeans.type,
            domesticClaim: formData.invoice.paymentMeans.domesticClaim,
        };
    }
    if (formData.invoice.paymentMeans.type === "NotSpecified" || formData.invoice.paymentMeans.type === "MutuallyAgreed") {
        return {
            type: formData.invoice.paymentMeans.type
        };
    }
    var paymentMeansFull = {
        type: formData.invoice.paymentMeans.type,
        domesticTransfer: {
            accountNumber: 0,
            accountTypeNumber: 0,
            bankNumber: 0,
            paymentIdentifier: 0
        },
        domesticClaim: {
            accountNumber: 0,
            bankNumber: 0,
        }
    };
    return paymentMeansFull;
};
